var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuiasPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.32,
    height: 34.999,
    viewBox: "0 0 27.32 34.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21162",
    "data-name": "Grupo 21162",
    transform: "translate(-1390.742 -980.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21161",
    "data-name": "Grupo 21161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15936",
    "data-name": "Trazado 15936",
    d: "M1418.062,989.667v-.076a1.239,1.239,0,0,0-.368-.882l-8.052-7.978h0a.682.682,0,0,0-.059-.049,1.038,1.038,0,0,0-.132-.106h0c-.028-.019-.06-.031-.089-.048a1.074,1.074,0,0,0-.122-.061h-.005a1.065,1.065,0,0,0-.121-.037c-.035-.01-.069-.024-.106-.031h0a1.258,1.258,0,0,0-.244-.032h-16.782a1.24,1.24,0,0,0-1.24,1.24h0v32.518a1.24,1.24,0,0,0,1.239,1.241h24.84a1.242,1.242,0,0,0,1.241-1.241h0Zm-8.057-5.064,3.821,3.821h-3.821Zm-16.782,28.282V982.849h14.3v6.818a1.241,1.241,0,0,0,1.24,1.241h6.818v21.977Z",
    fill: "#a867ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15937",
    "data-name": "Trazado 15937",
    d: "M1411.748,1004.114a8.609,8.609,0,0,0-3.542-.548l-2.522-4.146a7.7,7.7,0,0,0,1.627-3.6,2.656,2.656,0,0,0-5.308.094,7.7,7.7,0,0,0,1.437,3.445l-2.561,4.207a8.606,8.606,0,0,0-3.542.545,2.555,2.555,0,0,0-1.1,3.443h0l.018.035a2.449,2.449,0,0,0,2.218,1.393h0a2.474,2.474,0,0,0,1.217-.31,8.276,8.276,0,0,0,2.392-3.142H1407a8.3,8.3,0,0,0,2.392,3.142,2.481,2.481,0,0,0,1.218.31,2.446,2.446,0,0,0,2.218-1.393,2.556,2.556,0,0,0-1.045-3.46h0Zm-13.039,2.84a.528.528,0,0,1-.231.047.455.455,0,0,1-.443-.3.575.575,0,0,1,.159-.8l0,0,.037-.022a4.929,4.929,0,0,1,1.557-.293,4.523,4.523,0,0,1-1.083,1.364Zm5.943-11.67c.607,0,.673.374.673.534a4.384,4.384,0,0,1-.718,1.642,4.322,4.322,0,0,1-.619-1.548.576.576,0,0,1,.514-.632h0a.538.538,0,0,1,.15,0Zm-1.436,8.264,1.326-2.182,1.326,2.182Zm7.833,3.157a.451.451,0,0,1-.442.3.52.52,0,0,1-.233-.048,4.555,4.555,0,0,1-1.077-1.359,4.92,4.92,0,0,1,1.556.293.573.573,0,0,1,.214.782l0,0-.017.028Z",
    fill: "#a867ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiasPdf);
export default __webpack_public_path__ + "static/media/Guias_PDF.f98eec0db4c454fcf177ba290f13c4f9.svg";
export { ForwardRef as ReactComponent };